export enum SortOrderEnum {
    ASC = 1,
    DESC = 2,
}

export const sortOrderNames: Record<SortOrderEnum, string> = {
    [SortOrderEnum.ASC]: 'ascending',
    [SortOrderEnum.DESC]: 'descending',
};
